import { Transition } from "@headlessui/react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import WajeezLogo from "@components/items/common/WajeezLogo";

import { navbarItems } from "./NavBar";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export const Sidebar = ({ isOpen, onClose }: SidebarProps) => {
  const navigate = useAppNavigate();

  const renderMenu = () => {
    return navbarItems.map((i) => {
      return (
        <div
          key={i.title}
          className="mt-8 flex items-center justify-start text-white active:opacity-80"
          onClick={() => {
            onClose();

            if (i.isExternal) {
              window.location.href = i.path;
            } else {
              navigate(i.path);
            }
          }}
        >
          <div className="text-[28px]">{i.Icon}</div>
          <div className="mr-4 text-[20px]">{i.title}</div>
        </div>
      );
    });
  };

  return (
    <Transition
      show={isOpen}
      enter="transition ease-in-out duration-300 transform"
      enterFrom="-translate-x-full"
      enterTo="translate-x-0"
      leave="transition ease-in-out duration-300 transform"
      leaveFrom="translate-x-0"
      leaveTo="-translate-x-full"
      className="fixed left-0 top-0 z-20 w-full"
    >
      <div className="absolute left-0 top-0 flex h-screen w-full flex-col items-start justify-start bg-[#2D2E35] pb-16 pe-4">
        <div
          className="absolute left-6 top-8 text-[22px] text-white opacity-75"
          onClick={onClose}
        >
          <X />
        </div>
        <Link to={"/login"} className="block pt-2">
          <WajeezLogo width={80} />
        </Link>
        <div className="flex h-full flex-col items-start justify-between px-4 pt-4">
          <div>{renderMenu()}</div>
        </div>
      </div>
    </Transition>
  );
};
